import i18next from 'i18next'

import { ValidateFormService } from 'services/ValidateFormService'
import { OrderLocationViewModel } from 'sections/LKSection/modules/OrderModule/stores/models/OrderLocationViewModel'
import { validatePickPointFiles } from 'sections/LKSection/shared/PickPointSharedModule/components/PickPointFilesForm/validate'
import { PickPointFilesViewModel } from 'sections/LKSection/shared/PickPointSharedModule/models/PickPointFilesViewModel'
import { Country } from 'shared/types/types'

import { validateOrderLocation } from '../../../components/Forms/OrderLocationForm/validate'
import { validateWorkConditions } from '../../../components/Forms/OrderWorkConditionsForm/validate'
import { OrderWorkConditionsViewModel } from '../../../stores/models/OrderWorkConditionsViewModel'
import { getOrderItemPageKey } from '../../../utils'

export class ValidateOrderUpdate extends ValidateFormService {
  validate = (
    locationModel: OrderLocationViewModel,
    workConditionsModel: OrderWorkConditionsViewModel,
    filesModel: PickPointFilesViewModel,
    country: Country,
    isMove: boolean = false,
  ) => {
    const errors: string[] = []

    errors.push(
      ...(validateOrderLocation.validate(locationModel, 'array', country, isMove) as string[]),
      ...(validateWorkConditions.validate(workConditionsModel, 'array') as string[]),
      ...(validatePickPointFiles.validate(filesModel, 'array') as string[]),
    )

    return this.hasNotErrors(errors, i18next.t(getOrderItemPageKey('обновления заявки')))
  }
}

export const validateOrderUpdate = new ValidateOrderUpdate()
